import { Container, Typography } from '@mui/material';
import styled from '@emotion/styled';
import {Grid} from '@mui/material';

const PacmanContainer = styled(Container)`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    padding-top:40px;
    padding-bottom:40px;
    background-image:linear-gradient(to bottom ,#000B29,#071D61,#071E63);
`
const ContentGrid = styled(Grid)`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
`
const Subheading = styled(Typography)`
    color:#fff;
    font-family:Emulogic-zrEw;
    font-size:18px;
    font-weight:400;
    text-align:center;
    @media (max-width: 600px){
        font-size:12px;
    }
`
const P = styled.p`
    color:#fff;
    font-family:poppins;
    font-size:15px;
    text-align:center;
    @media (max-width: 600px){
        font-size:10px;
    }
`
const HeadingWrapper = styled.div`
    margin-bottom:10px;
`
const HeadingImg = styled.img`
        width:100%;
`
const SocialWrapper = styled.div`
    display: flex;
    align-items: center;
    margin:30px 0px;
`
const SocialImg = styled.img`
    margin:0px 5px;
    @media (max-width: 1250px) and (min-width: 900px){
    width:40px;
    max-width:100%;
    }
`
const CopyRightContainer = styled(Container)`
    background:#000B29;
    padding-top:15px;
    padding-bottom:15px;
`
function Footer() {
  return (
    <>
        <PacmanContainer maxWidth="xxl" id="footer">
            <ContentGrid container item xs={12} sm={10} md={7}>
                <HeadingWrapper>
                    <HeadingImg data-aos="zoom-in" src="./assets/HeadingImg.png"/>
                </HeadingWrapper>                
                <SocialWrapper>
                    <a href="https://twitter.com/pacman_plus" data-aos="zoom-in"><SocialImg src="./assets/twitter.png" /></a>
                    <a href="https://t.me/pacman_plus_Eth" data-aos="zoom-in"><SocialImg src="./assets/telegram.png" /></a>
                </SocialWrapper>
                <Subheading variant='h3' data-aos="zoom-in">Disclosures And Legalease</Subheading>
                <P data-aos="zoom-in">Please note that Pacman is a decentralized gaming project that
                     operates on the Ethereum blockchain. Participation in the game 
                     involves inherent risks, and users should conduct their own research
                      and exercise caution. The project team is not responsible for any financial losses
                     or damages incurred while using the platform. Always adhere to the rules and regulations 
                     of your jurisdiction.
                    </P>
            </ContentGrid>
        </PacmanContainer>
        <CopyRightContainer maxWidth="xxl">
                <P>© 2023 by pacmantoken. All rights reserved!</P>
        </CopyRightContainer>
    </>
  );
}

export default Footer;
